import React from 'react';
import { Button } from './ui/button';
import { Rocket } from 'lucide-react';
import { runInfo } from '../mock/mock';

const RunPanel = () => {
  const percent = runInfo.progress;
  const circumference = 2 * Math.PI * 62;
  const offset = circumference - (percent / 100) * circumference;

  return (
    <aside className="rounded-2xl border border-white/5 bg-gradient-to-b from-[#0d0616] to-[#080410] p-6 flex flex-col">
      <p className="text-[10px] uppercase tracking-[0.25em] text-white/40 font-mono">Run actif</p>
      <h2 className="text-2xl font-bold text-white mt-2 font-mono">{runInfo.site}</h2>
      <p className="text-xs text-white/50 mt-0.5">Dernier run</p>

      <div className="relative mx-auto mt-6 mb-4">
        <svg width="170" height="170" viewBox="0 0 150 150">
          <defs>
            <linearGradient id="ringGrad" x1="0%" y1="0%" x2="100%" y2="100%">
              <stop offset="0%" stopColor="#f472b6" />
              <stop offset="100%" stopColor="#ec4899" />
            </linearGradient>
          </defs>
          <circle cx="75" cy="75" r="62" stroke="rgba(255,255,255,0.06)" strokeWidth="5" fill="none" />
          <circle
            cx="75" cy="75" r="62"
            stroke="url(#ringGrad)"
            strokeWidth="5"
            fill="none"
            strokeDasharray={circumference}
            strokeDashoffset={offset}
            strokeLinecap="round"
            transform="rotate(-90 75 75)"
            style={{ filter: 'drop-shadow(0 0 6px rgba(236,72,153,0.6))', transition: 'stroke-dashoffset 1s ease' }}
          />
        </svg>
        <div className="absolute inset-0 flex flex-col items-center justify-center">
          <span className="font-mono text-3xl text-cyan-300 tabular-nums">{runInfo.lastRunDuration}</span>
          <span className="text-[9px] uppercase tracking-[0.25em] text-white/40 font-mono mt-1">Dernier run</span>
        </div>
      </div>

      <div className="flex items-center justify-between mt-2">
        <span className="text-[10px] uppercase tracking-[0.2em] text-white/40 font-mono">Pages · Max</span>
        <span className="font-mono text-xl text-white tabular-nums">
          {runInfo.pages.current} <span className="text-white/40">/</span> {runInfo.pages.max}
        </span>
      </div>

      <div className="grid grid-cols-2 gap-3 mt-4">
        <MiniStat label="Produits" value={runInfo.products} />
        <MiniStat label="ETA (est.)" value={runInfo.eta} />
        <MiniStat label="Proxy" value={runInfo.proxy} accent="cyan" />
        <MiniStat label="Incidents" value={runInfo.incidents} accent="amber" />
      </div>

      <div className="mt-auto pt-6">
        <Button className="w-full bg-gradient-to-r from-cyan-400 to-cyan-500 hover:from-cyan-300 hover:to-cyan-400 text-slate-900 font-bold tracking-widest font-mono uppercase text-xs h-11 shadow-lg shadow-cyan-500/20">
          <Rocket className="h-4 w-4 mr-2" /> Lancer un crawl
        </Button>
        <p className="text-[10px] text-white/40 mt-2 leading-relaxed">Relève automatique toutes les 8 s pendant un crawl.</p>
      </div>
    </aside>
  );
};

const MiniStat = ({ label, value, accent }) => {
  const colors = { cyan: 'text-cyan-300', amber: 'text-amber-300' };
  return (
    <div className="rounded-lg border border-white/5 bg-black/30 px-3 py-2">
      <p className="text-[9px] uppercase tracking-[0.2em] text-white/40 font-mono">{label}</p>
      <p className={`font-mono text-lg mt-0.5 ${colors[accent] || 'text-white'}`}>{value}</p>
    </div>
  );
};

export default RunPanel;
